<div class="app-loader-backdrop" *ngIf="loading$ | async">
  <div class="app-loader-card">

    <div class="spinner-wrapper">
      <mat-progress-spinner mode="indeterminate" diameter="46"></mat-progress-spinner>
    </div>

    <div class="app-loader-title">
      {{ currentMessage | translate }}
    </div>

  </div>
</div>
